import React from 'react';
import {styled, Typography} from '@mui/material';
import SkeletonWrap from './SkeletonWrap';
import RequiredAsterisk from './RequiredAsterisk';

const TextFieldLabel = styled(Typography, {shouldForwardProp: p=>!p.startsWith('$')})`
    color: ${p=>p.theme.palette.text[p.$focused ? 'primary' : 'secondary']};
    transition: color 200ms ease-out;
`;

const SCInputLabel = props=>{
    let {skeleton, focused, label, required} = props;
    return <SkeletonWrap skeleton={skeleton}>
      <TextFieldLabel $focused={focused}>
        {label}
        {required&&<RequiredAsterisk/>}
      </TextFieldLabel>
    </SkeletonWrap>;
};

export default SCInputLabel;
